import { createFileRoute, redirect } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { DefiPortfolioPage } from "../../features/defi/pages/defi-portfolio-page";
import { portfolioSearchSchema } from "../../shared/utils/search-params-schema";

export const Route = createFileRoute("/_layout/defi/portfolio")({
  component: DefiPortfolioPage,
  validateSearch: zodValidator(portfolioSearchSchema),
  beforeLoad: ({ search }) => {
    // If protocolKey is present, redirect to the same route without it
    if (search.protocolKey) {
      throw redirect({
        to: "/defi/portfolio/positions",
        search: {
          protocolKey: undefined,
          position: undefined,
        },
      });
    }
  },
});
